import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '../../services/authentication.service';
import { DataSharedService } from '../../services/data-shared.service';
import { TimesheetService } from '../../services/timesheet.service';
import { UserService } from '../../services/user.service';
import { NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { SuccessModalComponent } from '../../components/success-modal/success-modal.component';
import { AccountGenerationLinkModalComponent } from '../../components/account-generation-link-modal/account-generation-link-modal.component';
import { SuccessModal } from '../../app.model';

@Component({
  selector: 'app-inactive-candidates',
  templateUrl: './inactive-candidates.component.html',
  styleUrls: ['./inactive-candidates.component.css']
})
export class InactiveCandidatesComponent implements OnInit {
  timesheets: any = [];
  candidates: any = [];
  allCandidates: any = [];
  loading: boolean = false;
  redirectedName!: string;
  totalCount: number = 0;
  candidateSearch: string = '';

  constructor( 
    private timesheetService: TimesheetService,
    public authService: AuthenticationService,
    public dataSharedService: DataSharedService,
    public userService: UserService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private activeModalService: NgbActiveModal,
    public dialog: MatDialog,
    private router: Router,) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.redirectedName = params?.name;
      this.getCandidates(1);
    });
  }

  async getCandidates(page: number, search? :string) {
    this.candidates = [];
    this.allCandidates = [];
    this.loading = true;
    this.timesheetService.getCandidates(page, search, 0).subscribe((res: any) => {
      this.totalCount = res.meta.total;
      this.candidates = res.data.filter((x: any) => x.role === 'Candidate');
      if (this.redirectedName) {
        this.candidates = this.candidates.filter((x: any) => x.name === this.redirectedName);
      }
      this.loading = false;
      this.allCandidates = this.candidates.slice();
    });
  }

  onStepChange(event: any) {
    this.getCandidates(event)
  }

  searchCandidate() {
    if(this.candidateSearch != '') {
      this.getCandidates(1, this.candidateSearch);
    } else {
      this.getCandidates(1);
    }
  }

  sortData(sort: Sort) {
    const data = this.candidates.slice();
    if (!sort.active || sort.direction === '') {
      this.allCandidates = data;
      return;
    }

    this.allCandidates = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'email':
          return compare(a.email, b.email, isAsc);
        case 'created_at':
          return compare(a.created_at, b.created_at, isAsc);
        default:
          return 0;
      }
    });
  }

  successModal(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });
    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 2000,
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

  activateAccount(candidateUuid: string) {
    this.userService.activateAccount(candidateUuid).subscribe({
      next: (response) => {
          this.successModal('Activated Successfully.');
          this.router.navigate(['candidates/active-candidates'])
      },
      error: (err) => {
      }
    });
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}